export const LOGIN_URL = {
  signIn: '/login/sign-in',
  forgotPwd: '/login/forgot-pwd',
  resetPwd: '/login/reset-pwd',
  changePwd: '/login/change-pwd',
  resendEmail: '/login/resend-email',
  licenseInvalid: '/login/license-invalid',
  register: '/login/register',
  thirdPartyCallback: '/login/third-party-callback',
  activateAccount: '/login/activate',
  activeCode: '/login/active-code',
  verify: '/login/verify'
}

export const GetQueryString = (name: string, url?: string) => {
  let search = window.location.search.substr(1)
  if (url && url.split('?').length === 2) {
    search = url.split('?')[1]
  }
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const r = search.match(reg)
  if (r != null) return unescape(r[2])
  return null
}

export const client = [
  {
    id: '8e6b0dc572a24a6b998d3201a1fcb3cb',
    host: 'portal-sso-ensaas.sa.wise-paas.com',
    catalog: 'portal-catalog-ensaas.sa.wise-paas.com',
  },
  {
    id: 'e5fa72dd3bb54f6f824ef55b3b26d9aa',
    host: 'portal-sso-ensaas.hz.wise-paas.com.cn',
    catalog: 'portal-catalog-ensaas.hz.wise-paas.com.cn',
  },
  {
    id: 'e8d30d2d86c04e4a8bd1d2c82855ba1e',
    host: 'portal-sso-ensaas.jp.wise-paas.com',
    catalog: 'portal-catalog-ensaas.jp.wise-paas.com',
  },
]

export const pattern = {
  // http://emailregex.com/
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp(
    '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    'i',
  ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i,
}

export const pwdReg = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!#$%&'()*+,-./:;<=>?@[\]^_`{|}~])(?=\S+$)(?!.*[\u0022\u005C]).{8,20}$/g;

export const appFactoryPwdReg = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/g;